/* Bull Ring Fabrics — Plan your curtains: how the fabric looks (2026-10-31, Abid).
   Product photos are often a scrunched or draped piece of cloth (the Bellissimo velvets, for one), and tiling that photo
   across a drawn curtain looks wrong. So the planner reads the photo once in the browser (Shopify's CDN allows it) and asks:
   is this one colour, or a print? Each pixel is divided by its own brightness so a fold's shadow and the lit face of a plain
   cloth count as the same colour; if few pixels differ from the usual colour it is plain, and the drawing is painted in the
   colour of the lit face rather than the folds. A print or a check keeps its photo. Loaded between -a.js and -b.js. */
(function () {
  var doc = document, CACHE = {};
  function finish(L, res) { L.done = true; L.mode = res.mode; L.rgb = res.rgb || null; var q = L.q; L.q = []; q.forEach(function (f) { try { f(L); } catch (e) {} }); }
  function study(im) {
    var n = 48, c = doc.createElement('canvas'); c.width = c.height = n; var g = c.getContext('2d');
    var w = im.naturalWidth, h = im.naturalHeight, s = Math.min(w, h) * 0.7; /* the middle 70%: skips the edge of the table or the label */
    g.drawImage(im, (w - s) / 2, (h - s) / 2, s, s, 0, 0, n, n);
    var d = g.getImageData(0, 0, n, n).data, px = [], lum = [], norm = [], i;
    for (i = 0; i < d.length; i += 4) {
      var r = d[i], gg = d[i + 1], b = d[i + 2], mx = Math.max(r, gg, b), l = 0.299 * r + 0.587 * gg + 0.114 * b;
      px.push([r, gg, b]); lum.push(l);
      if (l >= 40 && mx >= 50) norm.push([r / mx, gg / mx, b / mx]); /* deep shadow has no reliable colour */
    }
    if (norm.length >= 100) {
      function med(k) { var a = norm.map(function (p) { return p[k]; }).sort(function (x, y) { return x - y; }); return a[a.length >> 1]; }
      var m = [med(0), med(1), med(2)], other = 0;
      norm.forEach(function (p) { var dd = Math.sqrt((p[0] - m[0]) * (p[0] - m[0]) + (p[1] - m[1]) * (p[1] - m[1]) + (p[2] - m[2]) * (p[2] - m[2])); if (dd > 0.25) other++; });
      if (other / norm.length > 0.035) return { mode: 'photo', other: other / norm.length };
    }
    /* plain: the colour of the lit face, i.e. the brighter part of the cloth, leaving out the folds and any glare */
    var sorted = lum.slice().sort(function (a, b) { return a - b; }), lo = sorted[Math.floor(sorted.length * 0.5)], hi = sorted[Math.floor(sorted.length * 0.95)];
    var R = 0, G = 0, B = 0, k = 0;
    px.forEach(function (p, j) { if (lum[j] >= lo && lum[j] <= hi) { R += p[0]; G += p[1]; B += p[2]; k++; } });
    if (!k) return { mode: 'photo' };
    return { mode: 'flat', rgb: [Math.round(R / k), Math.round(G / k), Math.round(B / k)] };
  }
  /* look(url, cb): cb({mode:'flat', rgb:[r,g,b]} | {mode:'photo'}), straight away when this photo has been read before */
  function look(url, cb) {
    if (!url || /^(data|blob):/.test(url)) { cb({ done: true, mode: 'photo', rgb: null }); return; } /* the customer's own photo (Fabric planner page) is always shown as it is: a black and white print has no colour to tell it from plain cloth */
    var L = CACHE[url];
    if (L) { if (L.done) cb(L); else L.q.push(cb); return; }
    L = CACHE[url] = { done: false, q: [cb] };
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onerror = function () { finish(L, { mode: 'photo' }); };
    im.onload = function () { var res; try { res = study(im); } catch (e) { res = { mode: 'photo' }; } finish(L, res); };
    im.src = url;
  }
  window.__brfCpLook = { look: look, study: study, cache: CACHE };
})();
